import styled from 'styled-components';
import themes from '../../_shared/themes';
import headerImageMobile from '../../assets/external/header-image-mobile.jpg';
import headerImageDesktop from '../../assets/external/header-image-desktop.png';
import mainimage from '../../assets/external/main-image.jpg';
import tiahMarketingImage from '../../assets/external/tiah-marketing-image.png';
import locationIcon from '../../assets/external/location.jpg';
import Button from '../../_shared/components/Button';

export const TradeInAtHomeContainer = styled.div``;

export const Main = styled.div`
  margin: 0 auto;
  font-family: ${themes.FONT.REGULAR};
  background-color: ${themes.COLORS.BASE_INVERTED};
`;

export const Header = styled.div`
  text-align: center;
  position: relative;
  height: 765px;
  color: ${themes.COLORS.BASE};
  margin-bottom: -270px;
`;

Header.BackgroundContainer = styled.div`
  background: url(${headerImageMobile});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  height: 61%;
  position: absolute;
  top: 0;
  left: 0;

  @media only screen and (min-width: ${({ theme }) => theme.BP.TIAH_LARGE}) {
    background: url(${headerImageDesktop});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    height: 70%;
  }
`;

Header.LogoContainer = styled.div`
  z-index: 10;
  width: 100%;
  height: 375px;
  position: absolute;
  top: -60px;
  left: 0;
  background: linear-gradient(
    180deg,
    ${themes.COLORS.BASE_INVERTED} 0%,
    rgba(0, 0, 0, 0) 40%
  );
`;

Header.TiahLogo = styled.img`
  padding: 96px 0 160px;
  width: 117px;

  @media only screen and (min-width: ${({ theme }) => theme.BP.TIAH_LARGE}) {
    width: 156px;
    margin-right: 60%;
  }
`;

Header.ContentContainer = styled.div`
  width: 100%;
  height: 30%;
  position: absolute;
  top: 263px;
  left: 0;
  z-index: 15;

  @media only screen and (min-width: ${({ theme }) => theme.BP.TIAH_LARGE}) {
    top: 252px;
  }
`;

Header.Heading = styled.div`
  font-size: ${themes.FONT_SIZES.XXLARGE};
  line-height: ${themes.FONT_SIZES.XXLARGE};
  width: 303px;
  text-align: center;
  margin: 0 auto;
  padding-bottom: 24px;

  @media only screen and (min-width: ${({ theme }) => theme.BP.TIAH_LARGE}) {
    width: 661px;
    font-size: 54px;
    line-height: 54px;
    font-family: ${({ theme }) => theme.FONT.REGULAR};
  }
`;

Header.Subheading = styled.div`
  font-size: ${themes.FONT_SIZES.BASE};
  line-height: ${themes.FONT_SIZES.LARGE};
  width: 339px;
  text-align: center;
  margin: 0 auto;

  @media only screen and (min-width: ${({ theme }) => theme.BP.TIAH_LARGE}) {
    width: 507px;
  }
`;

Header.BlurContainer = styled.div`
  background-color: ${themes.COLORS.BASE_INVERTED};
  margin: 0 auto;
  width: 100%;
  height: 18%;
  position: absolute;
  top: 300px;
  left: 0;
  background: linear-gradient(
    180deg,
    ${themes.COLORS.BASE_INVERTED} 0%,
    rgba(0, 0, 0, 0) 100%
  );
  transform: rotate(180deg);

  @media only screen and (min-width: ${({ theme }) => theme.BP.TIAH_LARGE}) {
    height: 26%;
  }
`;

export const FormContainer = styled.div`
  background-color: ${themes.COLORS.BASE_INVERTED};
  margin: 0 auto;
  width: ${({ theme }) => theme.BP.TIAH_CUSTOM_MOBILE};
  padding: 45px 5px 10px 5px;
  width: 100%;
  height: 25%;
  position: absolute;
  top: 430px;
  left: 0;

  @media only screen and (min-width: ${({ theme }) => theme.BP.TIAH_LARGE}) {
    padding: 20px 0 135px;
    height: 0;
    top: 490px;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  padding: 8px;
  background: ${themes.COLORS.BASE};
  box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  width: 340px;
  margin: 35px auto 0 auto;

  @media only screen and (min-width: ${({ theme }) => theme.BP.TIAH_LARGE}) {
    width: 675px;
    flex-direction: row;
  }
`;

Form.StyledLocationIconContainer = styled.span`
  background: url(${locationIcon});
  width: 30px;
  height: 30px;
  background-position: center;
  background-size: 12px 20px;
  background-repeat: no-repeat;
  vertical-align: middle;
  text-align: center;
  margin: 8px 0 -34px 8px;

  @media only screen and (min-width: ${({ theme }) => theme.BP.TIAH_LARGE}) {
    margin: 15px 0 0 0;
  }
`;

Form.Input = styled.input`
  border: none;
  width: 242px;
  margin: 10px auto 25px auto;
  background: ${themes.COLORS.BASE};
  font-size: ${themes.FONT_SIZES.MEDIUM};
  line-height: ${themes.FONT_SIZES.MEDIUM};

  ::placeholder {
    font-style: normal;
    color: ${themes.COLORS.NEUTRAL_30};
    font-size: ${themes.FONT_SIZES.MEDIUM};
    line-height: ${themes.FONT_SIZES.MEDIUM};
  }

  @media only screen and (min-width: ${({ theme }) => theme.BP.TIAH_LARGE}) {
    width: 384px;
    margin: 0 auto 0 8px;
  }
`;

Form.StyledFindDealersButton = styled(Button.Primary)`
  width: 314px;
  margin: 0 auto;
  cursor: pointer;
  padding: 10px 12px;
  border-radius: 6px;

  @media only screen and (min-width: ${({ theme }) => theme.BP.TIAH_LARGE}) {
    white-space: nowrap;
    width: auto;
    margin: 10px auto;
  }
`;

export const PurposeContainer = styled.div`
  text-align: center;
  margin-top: 150px;
  background-color: ${themes.COLORS.BASE};
`;

PurposeContainer.PurposeHeading = styled.div`
  font-size: ${themes.FONT_SIZES.BASE};
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  line-height: 32px;
  letter-spacing: ${({ theme }) => theme.LETTER_SPACING.MEDIUM};
  color: ${themes.COLORS.NEUTRAL_90};
  margin: 0 auto;
  padding-top: 50px;
`;

PurposeContainer.PurposeSubHeading = styled.div`
  color: ${themes.COLORS.BASE_INVERTED};
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-size: ${themes.FONT_SIZES.XLARGE};
  line-height: 32px;
  width: 303px;
  margin: 0 auto;
  padding-top: 8px;

  @media only screen and (min-width: ${({ theme }) => theme.BP.TIAH_LARGE}) {
    width: 742px;
  }

  @media only screen and (min-width: 8042px) {
    width: 798px;
  }
`;

PurposeContainer.PurposeContent = styled.div`
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-size: ${themes.FONT_SIZES.BASE};
  line-height: 24px;
  color: ${themes.COLORS.NEUTRAL_30};
  width: 303px;
  margin: 0 auto;
  padding: 20px 0 50px 0;

  @media only screen and (min-width: ${({ theme }) => theme.BP.TIAH_LARGE}) {
    width: 742px;
  }

  @media only screen and (min-width: 800px) {
    width: 779px;
  }
`;

export const StepsContainer = styled.div`
  border: 1px solid ${themes.COLORS.BASE_INVERTED};
  background-color: ${themes.COLORS.DARKEST_GREY};

  & > div:first-child {
    margin-top: 23px;
  }

  & > div:last-child {
    margin-bottom: 20px;
  }

  @media only screen and (min-width: ${({ theme }) => theme.BP.TIAH_LARGE}) {
    padding: 30px 0 10px;
  }
`;

export const StepContainer = styled.div`
  margin: -1px auto;
  padding 25px 25px 10px 25px;
  background-color: ${themes.COLORS.DARKEST_GREY};

  @media only screen and (min-width: ${({ theme }) => theme.BP.TIAH_LARGE}) {
    display: flex;
    margin: 0 auto;
    padding: 0 0 20px 0;
    width: 739px;
    justify-content: space-between;
  }
`;

StepContainer.ContentContainer = styled.div`
  padding: 12px;

  @media only screen and (min-width: ${({ theme }) => theme.BP.TIAH_LARGE}) {
    width: 412px;
    margin: auto 0;
    padding: 0;
  }
`;

StepContainer.StepHeading = styled.div`
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  font-size: ${themes.FONT_SIZES.BASE_SIZE};
  line-height: 24px;
  letter-spacing: ${({ theme }) => theme.LETTER_SPACING.MEDIUM};
  padding-bottom: 10px;
  color: ${themes.COLORS.BASE};
`;

StepContainer.StepSubHeading = styled.div`
  font-size: ${themes.FONT_SIZES.XLARGE};
  line-height: 32px;
  letter-spacing: ${({ theme }) => theme.LETTER_SPACING.MEDIUM};
  padding-bottom: 10px;
  color: ${themes.COLORS.BASE};
`;

StepContainer.StepContent = styled.div`
  font-size: ${themes.FONT_SIZES.BASE_SIZE};
  line-height: 24px;
  color: ${themes.COLORS.NEUTRAL_70};
`;

StepContainer.StyledStepImage = styled.img`
  width: 303px;
  height: 260px;
  border-radius: 3px;
  margin: 0 auto 10px auto;
  filter: drop-shadow(0px 0px 60px rgba(0, 0, 0, 0.8));
  display: block;

  @media only screen and (min-width: ${({ theme }) => theme.BP.TIAH_LARGE}) {
    border-radius: 3px;
    margin: 0;
    width: 269px;
    height: 360px;
  }
`;

StepContainer.StepHyperLink = styled.span`
  color: white;
  cursor: pointer;
  border-bottom: 1px solid ${themes.COLORS.NEUTRAL_70};
`;

StepContainer.StyledGetStartedNowButton = styled(Button.Primary)`
  margin: 45px 0 30px 0;
  cursor: pointer;
  width: 303px;
  height: 36px;
  font-size: ${themes.FONT_SIZES.SMALL};
  line-height: ${themes.FONT_SIZES.SMALL};
  text-align: center;
  letter-spacing: ${({ theme }) => theme.LETTER_SPACING.MEDIUM};

  @media only screen and (min-width: ${({ theme }) => theme.BP.TIAH_LARGE}) {
    width: 246px;
  }
`;

export const DescriptionContainer = styled.div`
  border: 1px solid ${themes.COLORS.BASE_INVERTED};

  @media only screen and (min-width: ${({ theme }) => theme.BP.TIAH_LARGE}) {
    padding-bottom: 75px;
  }
`;

DescriptionContainer.ParentContainer = styled.div`
  position: relative;
  height: 492px;
  background-color: ${themes.COLORS.BASE_INVERTED};

  @media only screen and (min-width: ${({ theme }) => theme.BP.TIAH_LARGE}) {
    width: 72%;
    margin: 0 auto;
    height: 650px;
  }
`;

DescriptionContainer.TradeInAtHomeMainPhoto = styled.div`
  background: url(${mainimage});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  height: 414px;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;

  @media only screen and (min-width: ${({ theme }) => theme.BP.TIAH_LARGE}) {
    height: 500px;
  }
`;

DescriptionContainer.BackgroundContainer = styled.div`
  background: linear-gradient(
    180deg,
    ${themes.COLORS.BASE_INVERTED} 0%,
    rgba(0, 0, 0, 0) 100%
  );
  transform: rotate(180deg);
  width: 101%;
  height: 35%;
  position: absolute;
  top: 265px;
  left: 0;

  @media only screen and (min-width: ${({ theme }) => theme.BP.TIAH_LARGE}) {
    top: 340px;
    height: 27%;
  }
`;

DescriptionContainer.TradeInAtHomeBenefitsOverview = styled.div`
  position: absolute;
  top: 360px;
  left: 0px;
  width: 100%;

  @media only screen and (min-width: ${({ theme }) => theme.BP.TIAH_LARGE}) {
    top: 570px;
  }
`;

DescriptionContainer.BenefitsOverviewHeading = styled.div`
  text-align: center;
  margin: 0 auto;
  font-size: ${themes.FONT_SIZES.BASE};
  line-height: 32px;
  color: ${themes.COLORS.NEUTRAL_90};
  letter-spacing: ${({ theme }) => theme.LETTER_SPACING.MEDIUM};
`;

DescriptionContainer.BenefitsOverviewSubHeading = styled.div`
  text-align: center;
  margin: 0 auto;
  font-size: ${themes.FONT_SIZES.XLARGE};
  line-height: 32px;
  color: ${({ theme }) => theme.COLORS.BASE};
  padding-bottom: 30px;
  margin-bottom: -1px;
  width: 283px;

  @media only screen and (min-width: ${({ theme }) => theme.BP.TIAH_LARGE}) {
    width: 370px;
  }
`;

DescriptionContainer.ContentContainer = styled.div`
  @media only screen and (min-width: ${({ theme }) => theme.BP.TIAH_LARGE}) {
    display: flex;
    background-color: ${themes.COLORS.BASE_INVERTED};
    width: 72%;
    margin: 0 auto;
  }

  & > div:last-child {
    padding-bottom: 35px;
  }
`;

DescriptionContainer.BenefitContainer = styled.div`
  background-color: ${themes.COLORS.BASE_INVERTED};
  padding: 25px;
  color: ${({ theme }) => theme.COLORS.BASE};
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-size: ${themes.FONT_SIZES.BASE};
  line-height: 24px;
  margin-top: -1px;

  @media only screen and (min-width: ${({ theme }) => theme.BP.TIAH_LARGE}) {
    width: 325px;
    margin: 0 auto;
  }
`;

DescriptionContainer.BenefitContainer.BenefitHeading = styled.div`
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
`;

DescriptionContainer.BenefitContainer.BenefitContent = styled.div`
  color: ${themes.COLORS.NEUTRAL_70};
`;

DescriptionContainer.BenefitContainer.BenefitSubContent = styled.div``;

export const MarketingContainer = styled.div`
  background-color: ${themes.COLORS.GREY_BLACK};
  padding: 25px;
  border: 1px solid ${themes.COLORS.BASE_INVERTED};
  font-size: ${themes.FONT_SIZES.BASE};
  line-height: ${themes.FONT_SIZES.LARGE};
  margin-top: -1px;

  @media only screen and (min-width: ${({ theme }) => theme.BP.TIAH_LARGE}) {
    width: 89%;
    margin: 0 auto;
    border-radius: 6px;
    display: flex;
    justify-content: space-evenly;
  }

  @media only screen and (min-width: 769px) {
    width: 72%;
    margin: 0 auto;
    border-radius: 6px;
    display: flex;
    justify-content: space-evenly;
    position: relative;
  }
`;

MarketingContainer.Background = styled.div`
  @media only screen and (min-width: 769px) {
    background: url(${tiahMarketingImage});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    mix-blend-mode: screen;
    width: 52%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
`;

MarketingContainer.HeaderContainer = styled.div`
  @media only screen and (min-width: ${({ theme }) =>
      theme.BP.TIAH_LARGE}) and (max-width: 769px) {
    width: 39%;
  }

  z-index: 10;
`;

MarketingContainer.BlurContainer = styled.div`
  @media only screen and (min-width: 769px) {
    background: linear-gradient(
      270deg,
      ${themes.COLORS.DARKEST_GREY} 13.3%,
      rgba(25, 25, 25, 0) 93.98%
    );
    width: 340px;
    height: 100%;
    position: absolute;
    bottom: 0;
    right: 47%;
    z-index: 5;
  }
`;

MarketingContainer.ContentContainer = styled.div`
  @media only screen and (min-width: ${({ theme }) => theme.BP.TIAH_LARGE}) {
    width: 66%;
    z-index: 10;
  }
`;

MarketingContainer.MainHeading = styled.div`
  font-size: ${themes.FONT_SIZES.BASE};
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  line-height: 32px;
  letter-spacing: ${({ theme }) => theme.LETTER_SPACING.MEDIUM};
  color: ${themes.COLORS.NEUTRAL_90};
  padding: 20px 0;
`;

MarketingContainer.Heading = styled.div`
  font-size: ${themes.FONT_SIZES.XLARGE};
  line-height: 32px;
  color: ${themes.COLORS.BASE};
  padding-bottom: 25px;
  width: 260px;
`;

MarketingContainer.Subheading = styled.div`
  color: ${themes.COLORS.BASE};
  padding-bottom: 25px;
`;

MarketingContainer.Content = styled.div`
  color: ${themes.COLORS.NEUTRAL_70};
  padding-bottom: 25px;
`;

MarketingContainer.Subtext = styled.div`
  color: ${themes.COLORS.BASE};
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  padding-bottom: 15px;
`;

MarketingContainer.StatsContainer = styled.div`
  @media only screen and (min-width: ${({ theme }) => theme.BP.TIAH_LARGE}) {
    display: flex;
    flex-wrap: wrap;
    min-width: 300px;
  }
`;

MarketingContainer.StatContainer = styled.div``;

MarketingContainer.Stat = styled.div`
  color: ${themes.COLORS.BASE};
  font-size: ${themes.FONT_SIZES.XLARGE};
  line-height: ${themes.FONT_SIZES.XLARGE};
  padding-bottom: 5px;
  width: auto;
  max-width: 500px;
`;

MarketingContainer.StatSubtext = styled.div`
  font-size: ${themes.FONT_SIZES.BASE};
  line-height: ${themes.FONT_SIZES.LARGE};
  width: ${props => props.width};
  color: ${themes.COLORS.NEUTRAL_70};
  padding-bottom: 25px;
`;

MarketingContainer.TRlink = styled.a`
  display: block;
  padding: 25px 0;
  color: ${themes.COLORS.BASE};
  text-decoration: underline;
  font-size: ${themes.FONT_SIZES.BASE};
  line-height: ${themes.FONT_SIZES.BASE};
  cursor: pointer;
`;

export const FAQContainer = styled.div`
  background-color: ${themes.COLORS.BASE_INVERTED};
  padding: 25px 25px 35px 25px;
  margin-top: -1px;

  @media only screen and (min-width: ${({ theme }) => theme.BP.TIAH_LARGE}) {
    width: 72%;
    margin: 0 auto;
    display: flex;
    padding-top: 100px;

    & > div:not(:first-child) {
      padding-top: 36px;
    }
  }
`;

FAQContainer.ContentWrapper = styled.div`
  @media only screen and (min-width: ${({ theme }) => theme.BP.TIAH_LARGE}) {
    width: 25%;
    margin: 0 auto;
  }
`;

FAQContainer.Heading = styled.div`
  font-size: ${themes.FONT_SIZES.BASE};
  line-height: 32px;
  letter-spacing: ${({ theme }) => theme.LETTER_SPACING.MEDIUM};
  color: ${themes.COLORS.NEUTRAL_90};
  padding-top: 40px;
  margin: 0 auto;

  @media only screen and (min-width: ${({ theme }) => theme.BP.TIAH_LARGE}) {
    padding-top: 0;
  }
`;

FAQContainer.Subheading = styled.div`
  font-size: ${themes.FONT_SIZES.XLARGE};
  line-height: 32px;
  color: ${themes.COLORS.BASE};
  padding-bottom: 35px;
  width: 260px;

  @media only screen and (min-width: ${({ theme }) => theme.BP.TIAH_LARGE}) {
    width: 100%;
  }
`;

FAQContainer.Question = styled.a`
  color: ${themes.COLORS.BASE};
  display: block;
  text-decoration: underline;
  cursor: pointer;
  font-size: ${themes.FONT_SIZES.BASE};
  line-height: ${themes.FONT_SIZES.BASE};
  padding-bottom: 20px;
`;

export const StyledFooterLine = styled.div`
  width: 100%;
  height: 2px;
  background-color: ${themes.COLORS.BASE};

  @media only screen and (min-width: ${({ theme }) => theme.BP.TIAH_LARGE}) {
    width: 72%;
    height: 1px;
    margin: 0 auto;
  }
`;

export const Footer = styled.div`
  background-color: ${themes.COLORS.BASE_INVERTED};
  margin-top: 2px;
`;

Footer.TiahLogo = styled.img`
  padding: 35px 0 25px 0;
  width: 117px;
  margin: 0 auto;
  display: block;
`;

Footer.Copyright = styled.div`
  color: ${themes.COLORS.BASE};
  text-align: center;
  width: 303px;
  margin: 0 auto;
  padding-bottom: 18px;
  font-size: 16px;
  line-height: 24px;

  @media only screen and (min-width: ${({ theme }) => theme.BP.TIAH_LARGE}) {
    width: 62%;
  }
`;

Footer.Legal = styled.div`
  display: flex;
  justify-content: center;
  gap: 24px;
  padding-bottom: 45px;

  a {
    color: ${({ theme }) => theme.COLORS.BASE};
    text-decoration: underline;
  }
`;

/**
 * The styled components below are used in the TIAH customer flow
 * */

export const TiahDetailsContainer = styled.div`
  width: ${({ theme }) => theme.BP.TIAH_DETAILS_WIDTH};
  margin: 0 auto;
  padding: 40px 18px;
  text-align: center;
  min-height: 85vh;

  @media only screen and (max-width: ${({ theme }) =>
      theme.BP.TIAH_DETAILS_WIDTH}) {
    width: 100%;
  }
`;

export const TiahDetailsHeading = styled.div`
  font-size: ${({ theme }) => theme.FONT_SIZES.XLARGE};
  line-height: ${({ theme }) => theme.FONT_SIZES.XLARGE};
`;

export const TiahDetailsSubheading = styled.div`
  margin-top: 24px;
`;

export const TiahDetailsFormContainer = styled.div`
  text-align: left;
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  padding: 21px;
  margin-top: 24px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  background-color: ${({ theme }) => theme.COLORS.BASE};
`;

export const StyledContinueButton = styled(Button.Primary)`
  margin-top: 36px;
  width: 291px;
  border-radius: 6px;
  padding: 10px;
  text-transform: uppercase;
`;
